import React, { useState } from 'react'
import { ActivityIndicator, StyleSheet } from 'react-native'

import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { B2, Button, H5, colors as zetColors } from '@zet/design-system'
import { IconButton } from '@zet/design-system/index'
import { Stack, XStack } from '@zet/design-system/layout'
import { i18n } from '@zet/localization'
import { AppStackParamList } from '@zet/utils/interface'
import { useUnsafeVariable } from 'nativewind'
import { WebView } from 'react-native-webview'

import { ThankYou } from '../../assets/svg'
import { useNavigation } from '../../hooks/useNavigation'

export const WebViewScreen = ({
  route,
  navigation,
}: NativeStackScreenProps<AppStackParamList, 'WebViewScreen'>) => {
  const [successView, setSuccessView] = useState(false)
  const {
    url,
    backButtonNavigation,
    brandId,
    leadId,
    customerId,
    customerName,
    isFeedbackFlow = false,
  } = route.params
  const { navigate } = useNavigation()
  const [colorPrimary100] = useUnsafeVariable('--color-primary-100')

  const onClose = () => {
    backButtonNavigation
      ? navigation.replace(
          backButtonNavigation as never,
          {
            brandId,
            leadId,
            customerId,
            customerName,
          } as never
        )
      : navigation.goBack()
  }
  function _onNavigationStateChange(webViewState: { url: string }) {
    if (webViewState?.url?.split('/').includes('formResponse')) {
      setSuccessView(true)
    }
  }

  function handleNavigation() {
    navigate('HomeView')
  }

  return (
    <Stack className="flex-1 ">
      <XStack className="border-grays-40 justify-between border-b bg-white p-3">
        <XStack className="items-center justify-center">
          <IconButton
            type={'Close'}
            color={zetColors.grays[80]}
            onPress={onClose}
          />
        </XStack>
      </XStack>
      {successView ? (
        <>
          <Stack className="bg-neutral-white100 flex-1 items-center justify-center">
            <ThankYou />
            <H5>{i18n.t('myNetwork.thanksFeedback')}</H5>
            <B2 className="text-grays-70">
              {i18n.t('myNetwork.yourImportant')}
            </B2>
          </Stack>
          <Stack className="bg-neutral-white100 px-3 py-2">
            <Button className="w-full" onPress={handleNavigation}>
              {i18n.t('myNetwork.backTo')}
            </Button>
          </Stack>
        </>
      ) : (
        <WebView
          source={{
            uri: url,
          }}
          style={isFeedbackFlow ? '' : styles.webViewStyle}
          androidHardwareAccelerationDisabled
          startInLoadingState
          renderLoading={() => (
            <Stack className="flex-1 justify-start bg-white">
              <ActivityIndicator size={'large'} color={colorPrimary100} />
            </Stack>
          )}
          cacheEnabled
          onNavigationStateChange={_onNavigationStateChange}
        />
      )}
    </Stack>
  )
}

const styles = StyleSheet.create({ webViewStyle: { marginTop: -90 } })
